document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;

  const nav = document.querySelector('[data-navigation]');
  if (!nav) return;

  const isOpen = nav.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', String(isOpen));
});

const header = document.querySelector('.shop-header');

const updateHeaderState = () => {
  if (!header) return;
  header.classList.toggle('is-condensed', window.scrollY > 24);
};

updateHeaderState();
window.addEventListener('scroll', updateHeaderState, { passive: true });

document.querySelectorAll('[data-rotating-preview]').forEach((preview) => {
  const items = Array.from(preview.querySelectorAll('[data-preview-item]'));
  const visibleCount = Number(preview.dataset.visibleCount || 6);
  const interval = Number(preview.dataset.rotationInterval || 4000);

  if (items.length <= visibleCount) return;

  let start = 0;
  const render = () => {
    items.forEach((item, index) => {
      const offset = (index - start + items.length) % items.length;
      item.classList.toggle('is-hidden', offset >= visibleCount);
    });
  };

  render();
  window.setInterval(() => {
    start = (start + visibleCount) % items.length;
    render();
  }, interval);
});

document.querySelectorAll('[data-collection-filters]').forEach((filters) => {
  const grid = filters.nextElementSibling;
  if (!grid || !grid.matches('[data-product-grid]')) return;

  const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
  const controls = {
    search: filters.querySelector('[data-filter-search]'),
    origin: filters.querySelector('[data-filter-origin]'),
    edition: filters.querySelector('[data-filter-edition]'),
    year: filters.querySelector('[data-filter-year]'),
    character: filters.querySelector('[data-filter-character]'),
    sort: filters.querySelector('[data-filter-sort]'),
    reset: filters.querySelector('[data-filter-reset]'),
    count: filters.querySelector('[data-filter-count]')
  };

  cards.forEach((card, index) => {
    card.dataset.initialIndex = String(index);
  });

  const clean = (value) => String(value || '').trim();
  const normalized = (value) => clean(value).toLowerCase();

  const dedupeOptions = (select) => {
    if (!select) return;
    const seen = new Set();
    Array.from(select.options).forEach((option) => {
      const key = normalized(option.value || option.textContent);
      if (!key) return;
      if (seen.has(key)) {
        option.remove();
        return;
      }
      seen.add(key);
    });
  };

  [controls.origin, controls.edition, controls.year, controls.character].forEach(dedupeOptions);

  const getState = () => ({
    search: normalized(controls.search?.value),
    origin: normalized(controls.origin?.value),
    edition: normalized(controls.edition?.value),
    year: normalized(controls.year?.value),
    character: normalized(controls.character?.value),
    sort: controls.sort?.value || 'featured'
  });

  const compareText = (field, direction = 1) => (a, b) => {
    const valueA = normalized(a.dataset[field]);
    const valueB = normalized(b.dataset[field]);
    return valueA.localeCompare(valueB, undefined, { numeric: true }) * direction;
  };

  const compareNumber = (field, direction = 1) => (a, b) => {
    const valueA = Number(a.dataset[field] || 0);
    const valueB = Number(b.dataset[field] || 0);
    return (valueA - valueB) * direction;
  };

  const sortCards = (sort) => {
    const sorted = [...cards];
    if (sort === 'name-asc') sorted.sort(compareText('pinName', 1));
    if (sort === 'name-desc') sorted.sort(compareText('pinName', -1));
    if (sort === 'year-desc') sorted.sort(compareNumber('year', -1));
    if (sort === 'year-asc') sorted.sort(compareNumber('year', 1));
    if (sort === 'origin-asc') sorted.sort(compareText('origin', 1));
    if (sort === 'character-asc') sorted.sort(compareText('character', 1));
    if (sort === 'price-asc') sorted.sort(compareNumber('price', 1));
    if (sort === 'price-desc') sorted.sort(compareNumber('price', -1));
    if (sort === 'featured') sorted.sort(compareNumber('initialIndex', 1));
    sorted.forEach((card) => grid.appendChild(card));
  };

  const applyFilters = () => {
    const state = getState();
    let visible = 0;

    cards.forEach((card) => {
      const haystack = [
        card.dataset.title,
        card.dataset.pinName,
        card.dataset.origin,
        card.dataset.edition,
        card.dataset.year,
        card.dataset.character
      ].map(normalized).join(' ');

      const matchesSearch = !state.search || haystack.includes(state.search);
      const matchesOrigin = !state.origin || normalized(card.dataset.origin) === state.origin;
      const matchesEdition = !state.edition || normalized(card.dataset.edition) === state.edition;
      const matchesYear = !state.year || normalized(card.dataset.year) === state.year;
      const matchesCharacter = !state.character || normalized(card.dataset.character) === state.character;
      const isVisible = matchesSearch && matchesOrigin && matchesEdition && matchesYear && matchesCharacter;

      card.classList.toggle('is-hidden-by-filter', !isVisible);
      if (isVisible) visible += 1;
    });

    sortCards(state.sort);
    if (controls.count) {
      controls.count.textContent = `${visible} of ${cards.length} pins shown`;
    }
  };

  filters.addEventListener('input', applyFilters);
  filters.addEventListener('change', applyFilters);
  controls.reset?.addEventListener('click', () => {
    [controls.search, controls.origin, controls.edition, controls.year, controls.character].forEach((control) => {
      if (control) control.value = '';
    });
    if (controls.sort) controls.sort.value = 'featured';
    applyFilters();
  });

  applyFilters();
});
